import type { LeadMagnetSubmitPayload } from "../../core/api-client.js";
import type { EmpruntNonResidentFormModel } from "./ui-state.js";

export function mapEmpruntNonResidentFormToSubmitPayload(
  form: EmpruntNonResidentFormModel,
): LeadMagnetSubmitPayload {
  const revenuCapital = parseNumber(form.revenuCapital);
  const dettesAssociees = parseNumber(form.dettesAssociees);

  return {
    email: form.email.trim(),
    firstName: form.firstName.trim() || undefined,
    source: form.source.trim(),
    consent: true,
    honeypot: form.honeypot,
    answers: {
      paysResidence: form.paysResidence.trim(),
      statutProfessionnel: form.statutProfessionnel,
      revenuMensuel: form.revenuMensuel,
      chargesMensuelles: formatEuroAmount(form.chargesMensuelles),
      apportDisponible: form.apportDisponible,
      garantie: form.garantie,
      ...(revenuCapital !== undefined ? { revenuCapital } : {}),
      ...(dettesAssociees !== undefined ? { dettesAssociees } : {}),
    },
  };
}

function parseNumber(value: string): number | undefined {
  const normalized = value.trim().replaceAll(/\s+/g, "").replace(",", ".");
  if (!normalized) return undefined;
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : undefined;
}

function formatEuroAmount(value: string): string {
  const parsed = parseNumber(value);
  if (parsed === undefined) return "";
  return `${new Intl.NumberFormat("fr-FR", {
    maximumFractionDigits: 0,
  }).format(parsed)} €`;
}
